import Image from 'next/future/image';
import Link from 'next/link';

const PopularLocations = (props: any) => {
  return (
    <section className="convenient-locations">
      <div className="container">
        <h2 className="section-heading">{props?.title}</h2>
        <div className="location-cards">
          <div className="row justify-content-center g-3">
            {props?.popularLocationsData &&
              props?.popularLocationsData?.map((item: any, index: any) => (
                <div
                  key={index}
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                >
                  <div className="card sv-location-card">
                    <div>
                      <Image
                        sizes="(max-width: 375px) 300px, (max-width: 576px) 540px, (max-width: 768px) 355px, (max-width: 992px) 310px, (max-width: 1280px) 370px"
                        src={item?.Thumbnail?.data?.attributes?.url}
                        priority={true}
                        className="card-img-top"
                        alt={
                          item?.Thumbnail?.data?.attributes?.alternativeText ||
                          item?.Thumbnail?.data?.attributes?.name
                        }
                        width="350"
                        height="175"
                      />
                    </div>

                    <div className="card-body">
                      <h4 className="location-name">{item?.Title}</h4>
                      <Link href={item?.Link_Slug_or_URL || ''}>
                        <a className="text-decoration-none">
                          <span className="primary-card-btn">
                            {item?.Link_Text}
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularLocations;
